import { selector } from "./selector";
import { gSelector } from "../../app/selector";
import { translate } from "../../app/localisation";
import { crud } from "../../app/crud";
import { data } from "jquery";

let isClick = false

let arrStatus = ['#not_found', '#unformed', '#no_mk']

let langMessagesErrorSerialNumber = []
langMessagesErrorSerialNumber['mk'] = 'Серискиот број мора да содржи 11 знаци'
langMessagesErrorSerialNumber['en'] = 'The serial number must contain 11 characters'
langMessagesErrorSerialNumber['sr_Latin'] = 'Serijski broj mora sadržati 11 karaktera'
langMessagesErrorSerialNumber['sr_Cyrillic'] = 'Серијски број мора садржати 11 карактера'
langMessagesErrorSerialNumber['ba'] = 'Serijski broj mora sadržavati 11 karaktera'
langMessagesErrorSerialNumber['hr'] = 'Serijski broj mora sadržavati 11 znakova'
langMessagesErrorSerialNumber['gr'] = 'Ο αριθμός σειράς πρέπει να περιέχει 11 χαρακτήρες'
langMessagesErrorSerialNumber['me'] = 'Serijski broj mora sadržati 11 karaktera'
langMessagesErrorSerialNumber['tr'] = 'Seri numarası 11 karakter içermelidir'
langMessagesErrorSerialNumber['de'] = 'Die Seriennummer muss 11 Zeichen enthalten'

const checkTag = (e) => {
    e.preventDefault();

    isClick = true
    $(gSelector.modal.success.general).html("").hide();
    $(gSelector.modal.errors.general).html("").hide();
    $(selector.additionalBtns).remove();

    let serialNumber = $(selector.inputSerialNumber).val()
    if (serialNumber.length !== 11) {
        const lang = $(selector.lang).val()
        $(gSelector.modal.errors.general).html(langMessagesErrorSerialNumber[lang]).show()
        return
    }

    let data = {serial_number: serialNumber};
    const url = $(e.target).attr('href');

    $.ajax({
            async: true,
            url: url, 
            method: 'GET', 
            dataType: 'json',
            data: data,
            success: function (data) {
                $(gSelector.modal.success.general).html(data.message).show();
    
                if (arrStatus.indexOf(data.status) != -1 && data.status != '#full') {
                    $(gSelector.modal.success.general).after(data.html)
                }
                isClick = false;
            },
            error: function(data) {
                console.log(data)
                $(gSelector.modal.errors.general).html(translate(data.responseJSON.message)).show()
                isClick = false;
            }
        }) 

}
const reloadCaptcha = (e) => {
    e.preventDefault();

    $.ajax({
        type: 'GET', url: '/reload-captcha', success: function (data) {
            $(selector.captchaHolder).html(data.captcha);
        }
    });
}

export { checkTag, reloadCaptcha };